import { render, staticRenderFns } from "./FloatingComponents.vue?vue&type=template&id=54e644ea&scoped=true"
import script from "./FloatingComponents.vue?vue&type=script&lang=js"
export * from "./FloatingComponents.vue?vue&type=script&lang=js"
import style0 from "./FloatingComponents.vue?vue&type=style&index=0&id=54e644ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e644ea",
  null
  
)

export default component.exports